// extracted by mini-css-extract-plugin
module.exports = {"iconSpace":"style__iconSpace__IUCLZ"};